var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-draggable-resize-combo",
    {
      staticClass: "container",
      attrs: {
        x: _vm.barcode.X,
        y: _vm.barcode.Y,
        width: _vm.barcode.Width,
        height: _vm.barcode.Height,
        "min-width": 5,
        "min-height": 5,
      },
      on: {
        "update:x": function ($event) {
          return _vm.$set(_vm.barcode, "X", $event)
        },
        "update:y": function ($event) {
          return _vm.$set(_vm.barcode, "Y", $event)
        },
        "update:width": function ($event) {
          return _vm.$set(_vm.barcode, "Width", $event)
        },
        "update:height": function ($event) {
          return _vm.$set(_vm.barcode, "Height", $event)
        },
      },
    },
    [
      _c("img", {
        staticClass: "barcode",
        attrs: { src: "/img/winfakt-be-barcode.png", alt: "Barcode" },
        on: {
          mousedown: function ($event) {
            $event.preventDefault()
          },
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }